import { addDateDays } from '@inflip/shared';

import { todayInAdminZone } from './time-zone';

/** 어드민 시간대의 오늘 YYYY-MM-DD — date input 값·기간 필터 기준 (서버도 어드민 시간대로 읽는다) */
export function todayDateInput(): string {
  return todayInAdminZone();
}

/** 오늘 포함 최근 n일의 시작일 */
export function daysAgo(n: number): string {
  return addDateDays(todayInAdminZone(), -(n - 1));
}
